import ButtonComponent from "../components/button";
import ErrorModalComponent from "../components/error-modal-component";
import LiComponent from "../components/li";
import UlComponent from "../components/ul";
import {setItemError} from "../require/set-item-error";
import {isEmptyArray} from "../utils/is-empty-array";
import {RenderPosition, remove, render} from "../utils/render";
import {showRespectModal} from "../utils/show-respect-modal";

export default class LabelsController {
  constructor({className = ``, labels = [], itemId = ``}) {
    this._className = className;
    this._labels = labels;
    this._itemId = itemId;

    this._onErrorLabelClickHandler = this._onErrorLabelClickHandler.bind(this);
  }

  render(container) {
    if (isEmptyArray(this._labels)) {
      return;
    }

    const listComponent = new UlComponent(`${this._className}__labels labels`);
    render(container, listComponent.getElement(), RenderPosition.BEFOREEND);

    this._labels.forEach((label) => {
      const labelComponent = label.isError ? this._getErrorLabelComponent(label) : this._getLabelComponent(label);

      if (label.background) {
        labelComponent.getElement().style.backgroundColor = label.background;
      }

      render(listComponent.getElement(), labelComponent.getElement(), RenderPosition.BEFOREEND);
    });
  }

  _getLabelComponent(label) {
    return new LiComponent({
      className: `labels__item`,
      text: label.title,
    });
  }

  _getErrorLabelComponent(label) {
    const itemComponent = new LiComponent({
      className: `labels__item`,
      text: label.title,
    });

    const button = new ButtonComponent({
      className: `labels__button`,
      title: label.title,
    });

    button.setClickHandler(this._onErrorLabelClickHandler);

    render(itemComponent.getElement(), button.getElement(), RenderPosition.BEFOREEND);

    return itemComponent;
  }

  _onErrorLabelClickHandler() {
    const removePopup = () => {
      this._modalComponent.getElement().classList.add(`modal--hide`);
      document.querySelector(`body`).classList.remove(`overflowHidden`);
      document.removeEventListener(`keydown`, onEscPressModalHandler);
      setTimeout(() => remove(this._modalComponent), 1000);
    };

    const onEscPressModalHandler = (evt) => {
      if (evt.key === `Escape`) {
        removePopup();
      }
    };

    document.querySelector(`body`).classList.add(`overflowHidden`);
    document.addEventListener(`keydown`, onEscPressModalHandler);

    this._modalComponent = new ErrorModalComponent();
    render(document.querySelector(`body`), this._modalComponent.getElement(), RenderPosition.BEFOREEND);

    this._modalComponent.setCloseButtonClickHandler(() => removePopup());
    this._modalComponent.setOverlayClickHandler(() => removePopup());
    this._modalComponent.setSendButtonClickHandler((message = ``, cb) => {
      setItemError(this._itemId, message, () => {
        showRespectModal(`Сообщение отправлено`);
        removePopup();
        cb();
      }, () => {
        cb();
      });
    });

    this._modalComponent.setShowClass();
  }
}

// удалять все обработчики на попапе
// плюс удалять таймер
